import { Box, IconButton, styled } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import IconFontAwesome from './IconFontAwesome';
import { usePageClick } from 'new/hooks/usePageClick';
import { loadReleaseNotes } from 'new/utils/releasenotes';
import { TenantStruct } from 'new/types/util';
import { TENANT } from 'new/tenants';

const StyledBox = styled(Box)(() => ({
  padding: '0!important',
  position: 'relative',
  '.rnw-count': {
    top: 'unset!important',
    bottom: 0,
    right: '-5px!important',
  },
}));

type Props = {
  activeOfficeId: string;
};

type RNWProps = {
  account: string;
  selector?: string;
  modal_css?: string;
};

const initProps: TenantStruct<RNWProps> = {
  dhq: {
    account: 'dentalhq.releasenotes.io',
    modal_css: 'https://s3.amazonaws.com/market_materials/releasenotes.css',
  },
  vhq: {
    account: 'vision-hq.releasenotes.io',
  },
};

const ReleaseNotesButton: React.FC<Props> = ({ activeOfficeId }) => {
  const ref = useRef<HTMLDivElement>();
  const { mutate: logClick } = usePageClick();

  useEffect(() => {
    loadReleaseNotes();
    window.rnw('init', initProps[TENANT.id]);

    const interval = setInterval(() => {
      const badges = document.querySelectorAll('.rn-badge');
      if (badges.length && ref.current && badges[0].children.length) {
        ref.current.appendChild(badges[0].children[0].cloneNode(true));
        clearInterval(interval);
      }
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const removeBadge = () => {
    const badges = ref.current?.querySelectorAll('.rnw-count');
    if (badges?.length) {
      badges[0].remove();
    }
  };

  return (
    <StyledBox ref={ref}>
      <IconButton
        onClick={() => {
          window.rnw('show');
          removeBadge();
          logClick({
            dentistInfoId: parseInt(activeOfficeId),
            clickEvent: 'Release Notes Icon',
          });
        }}
      >
        <IconFontAwesome name="faBell" color="grey400" size="sm" />
      </IconButton>
    </StyledBox>
  );
};

export default React.memo(ReleaseNotesButton);
